module.exports = __webpack_public_path__ + "static/img/banner1.e3bd844.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CopierSelfprinting/banner1.png
// module id = +Fi1
// module chunks = 10